const my_profile = {
  viewMyClubSeacretProfile: "הצג את פרופיל ClubSeacret שלי", // translated
  viewMoreDetails: "הצג פרטים נוספים", // translated
  verifiedEmail: "אימייל מאומת", // translated
  unverifiedEmail: "אימייל לא מאומת", // translated
  createdFrom: "נוצר מ", // translated
  createdTo: "נוצר עד", // translated
  selectStatus: "בחר סטטוס...", // translated
  searchByTitle: "חפש לפי כותרת...", // translated
  pushNotifications: "התראות Push", // translated 
  pushNotificationsDescription: "קבל התראות דפדפן לעדכונים ואירועים חשובים", // translated 
  pushNotificationsNotSupported: "התראות Push אין נתמכות בדפדפן זה", // translated 
  pushNotificationsDeniedMessage: "הרשאת ההתראה נדחתה. אנא הפעל התראות בהגדרות הדפדפן כדי לקבל התראות Push.", // translated 
  pushNotificationsEnabled: "התראות Push הופעלו בהצלחה", // translated 
  pushNotificationsDisabled: "התראות Push בוטלו בהצלחה", // translated 
  userInformationMissing: "חסרות פרטי משתמש", // translated 
  failedToUpdatePushNotifications: "נכשל בעדכון הגדרות התראות Push", // translated 
  notificationPermissionDenied: "הרשאת ההתראה נדחתה. אנא הפעל אותה בהגדרות הדפדפן.", // translated 
  notificationPermissionRequired: "צריך הרשאת התראה כדי להפעיל התראות Push", // translated 
  notSupported: "לא נתמך", // translated 
  permissionDenied: "הרשאה נדחתה", // translated 
  permissionNotRequested: "הרשאה לא התבקשה", // translated 
  enabled: "מופל", // translated 
  disabled: "מושב", // translated 
};


export default my_profile;
